import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { getInvoiceById } from '../../api/invoices';
import GenererPdfFacture from './genererPdfFacture';
import ReactDOM from 'react-dom';

const InvoicePreview = ({ invoiceId, show, onHide, companyInfo }) => {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show && invoiceId) {
      fetchInvoice();
    }
  }, [invoiceId, show]);

  const fetchInvoice = async () => {
    try {
      setLoading(true);
      const data = await getInvoiceById(invoiceId);
      setInvoice(data);
      setError('');
    } catch (err) {
      console.error('Erreur lors du chargement de la facture:', err);
      setError('Impossible de charger les détails de la facture');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    if (!invoice) return;
    
    // Créer un élément pour le rendu du PDF
    const pdfElement = document.createElement('div');
    document.body.appendChild(pdfElement);
    
    // Utiliser le générateur de PDF avec la fonction de téléchargement
    ReactDOM.render(
      <GenererPdfFacture 
        invoice={invoice} 
        company={companyInfo} 
        onDownload={(blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `facture_${invoice.invoiceNumber}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          document.body.removeChild(pdfElement);
          ReactDOM.unmountComponentAtNode(pdfElement);
        }}
      />,
      pdfElement
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Aperçu de la facture</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
            <p className="mt-2">Chargement de la facture...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : invoice ? (
          <GenererPdfFacture invoice={invoice} company={companyInfo} showPreview={true} />
        ) : (
          <div className="alert alert-warning">Aucune donnée de facture disponible</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fermer
        </Button>
        {invoice && (
          <Button variant="primary" onClick={handleDownload}>
            Télécharger le PDF
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default InvoicePreview;